(function(){
  function build(){
    var secs=document.querySelectorAll('.shopify-section[id$="__related1"],.shopify-section[id$="__related2"],.shopify-section[id$="__best"]');
    for(var i=0;i<secs.length;i++){(function(sec){
      var ul=sec.querySelector('ul.slider--mobile')||sec.querySelector('ul.product-grid');
      if(!ul||ul.getAttribute('data-rena-more'))return;
      ul.setAttribute('data-rena-more','1');
      var link=sec.querySelector('a[href*="/collections/"]:not(.card__heading):not(.full-unstyled-link)');
      var href=(link&&link.getAttribute('href'))||'/collections/all';
      var li=document.createElement('li');li.className='grid__item slider__slide rena-viewall';
      li.innerHTML='<a href="'+href+'" class="rena-viewall__card"><span class="rena-viewall__circle" aria-hidden="true">&rarr;</span><span class="rena-viewall__t">すべて見る</span></a>';
      ul.appendChild(li);
      var prog=document.createElement('div');prog.className='rena-prog';prog.innerHTML='<span></span>';
      ul.parentNode.insertBefore(prog,ul.nextSibling);
      var bar=prog.firstChild;
      function upd(){var max=ul.scrollWidth-ul.clientWidth;if(max<=2){prog.style.display='none';return;}prog.style.display='';var w=Math.max(ul.clientWidth/ul.scrollWidth*100,12);bar.style.width=w+'%';bar.style.transform='translateX('+(ul.scrollLeft/max*(100-w)/w*100)+'%)';}
      ul.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
    })(secs[i]);}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build);else build();
  document.addEventListener('shopify:section:load',build);
})();
